export type EnvironmentConfig = {
    REACT_APP_PRIVACY_POLICY_URL: string
    REACT_APP_TERMS_AND_CONDITIONS_URL: string
}

export const env = process.env as unknown as  EnvironmentConfig;

